<template>
    <div>
        <div id="shopping-cart">
            <!-- Page Header -->
            <div class="container-fluid gray">
                <div class="container">
                    <Page-Header />
                </div>
            </div>
        </div>

        <div class="container-fluid toprow">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <Alerts />
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid">
            <div class="container">
                <div id="cartMain" class="row">
                    <div class="col-lg-4 col-lg-push-8 col-md-4 col-md-push-8 col-sm-12 col-xs-12">
                        <Cart-Right />
                    </div>
                    <div class="col-lg-8 col-lg-pull-4 col-md-8 col-md-pull-4 col-sm-12 col-xs-12">
                        <Cart-Table />
                        <div id="cartOptionsHolder"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import axios from "axios";
    import PageHeader from '../components/PageHeader'
    import CartRight from '../components/CartRight'
    import CartTable from '../components/CartTable'
    import Alerts from '../../shared/components/Alerts'
    import useCart from '../composables/useCart'

    export default {
        name: 'Cart',
        components: {
            PageHeader,
            CartRight,
            CartTable,
            Alerts
        },
        setup () {
            const { updateCartCountBadge } = useCart();
            updateCartCountBadge();
        }
    }
</script>
